import DropdownSelect, { DropdownSelectProps } from './DropdownSelect';

export type { DropdownSelectProps };
export default DropdownSelect;
